import { render } from "./SpotInput.vue?vue&type=template&id=127acf60&scoped=true"
import script from "./SpotInput.vue?vue&type=script&lang=js"
export * from "./SpotInput.vue?vue&type=script&lang=js"

import "./SpotInput.vue?vue&type=style&index=0&id=127acf60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127acf60"]])

export default __exports__